import { render, staticRenderFns } from "./AbcCurveProducts.vue?vue&type=template&id=5c7b541c"
import script from "./AbcCurveProducts.vue?vue&type=script&lang=js"
export * from "./AbcCurveProducts.vue?vue&type=script&lang=js"
import style0 from "./AbcCurveProducts.vue?vue&type=style&index=0&id=5c7b541c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports